import React, { useState, useEffect } from 'react';
import '../assets/css/Slider.css'; 
import hero1 from '../assets/images/hero1.png';  
import hero2 from '../assets/images/hero2.png';  
import hero3 from '../assets/images/hero3.png';  


const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    { img: hero1, caption: 'Discover Innovation', link: '/innovation' },
    { img: hero2, caption: 'Empowering Your Business', link: '/innovation' },
    { img: hero3, caption: 'Technology for a Better Future', link: '/innovation' },
  ];

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + slides.length) % slides.length);
  };

   // Set interval to auto-slide every 3 seconds
   useEffect(() => {
    const interval = setInterval(nextSlide, 3000); // 3000ms = 3 seconds
    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []);

  return (
    <div className="slider-container">
      <button className="prev" onClick={prevSlide}> &#8592; </button>
      <div className="slider">
        <img src={slides[currentSlide].img} alt={`Slide ${currentSlide + 1}`} />
        <div className="caption">
        <a href={slides[currentSlide].link}>
          <h2>{slides[currentSlide].caption}</h2>
          </a>
        </div>
      </div>
      <button className="next" onClick={nextSlide}> &#8594; </button>
    </div>
  );
};

export default Slider;
